import React from "react"
import styled from "styled-components"
import Family from "../images/family.jpg";
import { graphql, useStaticQuery } from "gatsby"
import StarBar from "./StarBar"

const MessageTriangles = {
  left: "border-left: 0",
  right: "border-right: 0",
  center: "",
}

const ReviewContainer = styled.div`
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    background: #004e92;  
    border: 1px solid #004e92;
    border-radius: 20px;
    padding: 1rem 1rem;
    position: relative;
    margin: 0 0 0 0;
    min-height: 350px;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-top-color: #004e92;
      border-bottom: 0;
      ${props => props.pos ? MessageTriangles[props.pos] : ""};
      margin-left: -10px;
      margin-bottom: -20px;   
    }
    h5 {
      text-align: center;
      font-family: "Montserrat", serif;
      color: #fff;
      font-weight: 700;
      margin: 0 0 1.5rem 0;
    }
    
`

const ReviewText = styled.p`
      color: #fff;
      margin-bottom: 1rem;
`

const ReviewSection = styled.div`
  margin: 10vh 0 0 0;
  background: linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${props => props.bg.src});
  padding: 5vh 0 10vh 0;
  
  .column {
    margin-bottom: 3rem;
    @media only screen and (min-width: 1280px) {
       margin-bottom: 0;
    }
  }

`

const Reviewer = styled.p`
  position: absolute;
  bottom: 1rem;
  color: #fff;
  font-weight: 700;
`

const SectionTitle = styled.h2`
  margin: 5vh 0 10vh 0;
  color: #fff;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
`

const ColumnSpacer = styled.div`
  width: 25%;
  display: none;
  @media only screen and (min-width: 1024px) {
    display: block;
  }
  @media only screen and (min-width: 1280px) {
  display: none;
  }
  
`
const HomeReviewsSpanish = (props) => {
  const data = useStaticQuery(graphql`
      query HomeReviewsSpanishQuery {
          file(relativePath: {eq: "family.jpg"}) {
              id
              childImageSharp {
                  fluid(maxWidth: 1920) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
      }
  `)

  return (

    <ReviewSection bg={data.file.childImageSharp.fluid}>
      <SectionTitle>What The Valley Says</SectionTitle>
      <div className="container is-fluid">
        <div className="columns is-multiline">
          <div className="column is-one-third-widescreen is-half-desktop is-12">
            <ReviewContainer pos="left">
              <h5>Highly Recommended!</h5>
              <StarBar starCount={5}/>
              <ReviewText>"After shopping around they offered us the best price along with the
                security of being licensed & insured for my families protection. They had great customer service through
                the whole process. They offer affordable prices with brand names. We will surely recommend to our friends
                and family for their next A/C installs."</ReviewText>
              <Reviewer>- Patricia Perales</Reviewer>
            </ReviewContainer>
          </div>
          <div className="column is-one-third-widescreen is-half-desktop is-12">
            <ReviewContainer pos="center">
              <h5>Super Professional</h5>
              <StarBar starCount={5}/>
              <ReviewText>"The wonderful staff at air service expert helped us promptly replace our old ac unit which died on us
                amidst the summer. Not only were they fast but super professional and explained every step of the way.
                Thank you for help!"</ReviewText>
              <Reviewer>- Martha Lopez</Reviewer>
            </ReviewContainer>
          </div>
          <ColumnSpacer></ColumnSpacer>
          <div className="column is-one-third-widescreen is-half-desktop is-12">
            <ReviewContainer pos="right">
              <h5>No Issues</h5>
              <StarBar starCount={4}/>
              <ReviewText>"after looking around for a good and not too expensive a/c company i settled on this company. they came
                and gave me a good quote on a new full installation on a 4 1/2 Rheem central a/c. a few (2-3) days later
                they came and installed everything in less than a day. and a fine job they did i should mention. i haven't
                had any issues with my a/c or the installation over a year later. i highly recommend this fine
                company."</ReviewText>
              <Reviewer>- Hector de la Cruz</Reviewer>
            </ReviewContainer>
          </div>
        </div>
      </div>
    </ReviewSection>

  )
}

export default HomeReviewsSpanish